import { render } from "./ReportDGII.vue?vue&type=template&id=64442e7d"
import script from "./ReportDGII.vue?vue&type=script&lang=js"
export * from "./ReportDGII.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__